// phonics_data_lt03.js
// Letter Teams L03 - L3 Long Vowel o - Magic e - CVCe
// 路由：/phonics/lt03

const MEDIA_BASE = '/media/phonics/lt03';
const V = 'v1';

export const letterDataLt03 = {
  id: 'lt03',
  letter: 'L03',
  title: 'L3 Long Vowel o - Magic e - CVCe',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P4-P6: 三段故事（story-video-left-lines-right）
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals saw a hole.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "What is in it?", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Green got a rope.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "He put it in the hole.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "The pals went down the rope.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Pink saw a cone.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "I like this cone.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Yellow saw a rose.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "I like this rose.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Oh no!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Here comes a mole!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "This is my home!", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "The mole was mad.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Give me my cone.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Give me my rose.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Let's go home!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "The pals went up the rope.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
      ],
    },
  ],
};
